import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import PendingIcon from '@mui/icons-material/Pending';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const woStatusToIcon = {
    "OPN": <PanoramaFishEyeIcon sx={{ color: '#dbdbdb' }}/>,
    "PRG": <PendingIcon sx={{ color: '#00b0ff' }}/>,
    "CMP": <CheckCircleIcon sx={{ color: '#00c853' }}/>
}

export const woStatusCodeToName ={
    "OPN": "Open",
    "PRG": "In Progress",
    "CMP": "Completed"
}

export const woStatusNameToCode = {
    "Open": "OPN",
    "In Progress": "PRG",
    "Completed": "CMP"
}